/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Reasons_Timingnotright4Inputs */

const en_coinvestments_declinedeal_reasons_timingnotright4 = /** @type {(inputs: Coinvestments_Declinedeal_Reasons_Timingnotright4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing not right`)
};

/**
* | output |
* | --- |
* | "Timing not right" |
*
* @param {Coinvestments_Declinedeal_Reasons_Timingnotright4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_reasons_timingnotright4 = /** @type {((inputs?: Coinvestments_Declinedeal_Reasons_Timingnotright4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Reasons_Timingnotright4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_reasons_timingnotright4(inputs)
});
export { coinvestments_declinedeal_reasons_timingnotright4 as "coInvestments_declineDeal_reasons_timingNotRight" }